import {Alert, Breadcrumb, Button, Spin, Tabs} from "antd";
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import {DashboardWrapper} from "../../../../layouts/dashboard-wrapper";
import {StyledPageWrapper} from "../../../../styles/dashboard/calls/calls";
import {LiveClassesTemplateWidget} from "../../../../components/live-classes/template-widget/template-widget";
import {AttendeesComponent} from "../../../../components/live-classes/attendees";
import {ShareClassWidget} from "../../../../components/live-classes/share-class-widget";
import {useEffect, useState} from "react";
import {useGetLiveEventContext} from "../../../../liveEvents/useCases/edit-live-event/context/get-live-event";
import {EditLiveEventBasicForm} from "../../../../liveEvents/useCases/edit-live-event/basic-form";
import {ErrorBoundary} from "react-error-boundary";
import {EditLiveEventCheckoutForm} from "../../../../liveEvents/useCases/edit-live-event/checkout-form";
import {EditLiveEventCohost} from "../../../../liveEvents/useCases/edit-live-event/co-host";
import {OfferingAutomations} from "../../../../components/offering-form/automations-step";

type TabKeys = "form" | "checkoutForm" | "cohost" | "automations" | "insights";

const ViewLiveClassPage = () => {
  const {
    state: {isLoadingLiveEvent, liveEventData, isFetchingLiveEvent},
  } = useGetLiveEventContext();
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get("activeTab");
  const [defaultActiveKey, setDefaultActiveKey] = useState<TabKeys>("form");
  const navigate = useNavigate();

  useEffect(() => {
    if (activeTab) {
      if (activeTab === "checkoutForm") {
        setDefaultActiveKey(activeTab);
      }
      if (activeTab === "cohost") {
        setDefaultActiveKey(activeTab);
      }
      if (activeTab === "insights") {
        setDefaultActiveKey(activeTab);
      }
      if (activeTab === "automations") {
        setDefaultActiveKey(activeTab);
      }
    }
  }, [activeTab]);

  function handleTabClick(key: string) {
    if (key === "form") {
      setDefaultActiveKey("form");
      navigate(`${window.location.pathname}?activeTab=form`);
    }
    if (key === "checkoutForm") {
      setDefaultActiveKey("checkoutForm");
      navigate(`${window.location.pathname}?activeTab=checkoutForm`);
    }
    if (key === "cohost") {
      setDefaultActiveKey("cohost");
      navigate(`${window.location.pathname}?activeTab=cohost`);
    }
    if (key === "automations") {
      setDefaultActiveKey("automations");
      navigate(`${window.location.pathname}?activeTab=automations`);
    }
    if (key === "insights") {
      setDefaultActiveKey("insights");
      navigate(`${window.location.pathname}?activeTab=insights`);
    }
  }

  return (
    <DashboardWrapper pageTitle={liveEventData.name}>
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to="/live-classes">Live events</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <span
            style={{
              opacity: isFetchingLiveEvent ? 0.2 : 1,
            }}
          >
            {" "}
            {isLoadingLiveEvent ? (
              <Spin />
            ) : liveEventData.name ? (
              liveEventData.name.substring(0, 20) + "..."
            ) : (
              "Draft name"
            )}
          </span>
        </Breadcrumb.Item>
      </Breadcrumb>
      <StyledPageWrapper>
        <div className="main-area">
          <div style={{marginTop: "1.8rem"}}>
            <Spin spinning={isFetchingLiveEvent}>
              <Tabs
                defaultActiveKey={defaultActiveKey}
                activeKey={defaultActiveKey}
                onTabClick={(key) => handleTabClick(key)}
              >
                <Tabs.TabPane tab="Event information" key="form">
                  <ErrorBoundary
                    FallbackComponent={({error, resetErrorBoundary}) => (
                      <>
                        <div style={{marginTop: "1.8rem"}}>
                          <Alert
                            message="Sorry, something went wrong."
                            showIcon
                            description={error.message}
                            type="error"
                            action={
                              <Button
                                onClick={() => {
                                  resetErrorBoundary();
                                }}
                                size="small"
                                danger
                              >
                                Reset
                              </Button>
                            }
                          />
                        </div>
                      </>
                    )}
                  >
                    <EditLiveEventBasicForm />
                  </ErrorBoundary>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Checkout form" key="checkoutForm">
                  <ErrorBoundary
                    FallbackComponent={({error, resetErrorBoundary}) => (
                      <>
                        <div style={{marginTop: "1.8rem"}}>
                          <Alert
                            message="Sorry, something went wrong."
                            showIcon
                            description={error.message}
                            type="error"
                            action={
                              <Button
                                onClick={() => {
                                  resetErrorBoundary();
                                }}
                                size="small"
                                danger
                              >
                                Reset
                              </Button>
                            }
                          />
                        </div>
                      </>
                    )}
                  >
                    <EditLiveEventCheckoutForm />
                  </ErrorBoundary>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Add co-host" key="cohost">
                  <ErrorBoundary
                    FallbackComponent={({error, resetErrorBoundary}) => (
                      <>
                        <div style={{marginTop: "1.8rem"}}>
                          <Alert
                            message="Sorry, something went wrong."
                            showIcon
                            description={error.message}
                            type="error"
                            action={
                              <Button
                                onClick={() => {
                                  resetErrorBoundary();
                                }}
                                size="small"
                                danger
                              >
                                Reset
                              </Button>
                            }
                          />
                        </div>
                      </>
                    )}
                  >
                    <EditLiveEventCohost />
                  </ErrorBoundary>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Automations" key="automations">
                  <ErrorBoundary
                    FallbackComponent={({error, resetErrorBoundary}) => (
                      <>
                        <div style={{marginTop: "1.8rem"}}>
                          <Alert
                            message="Sorry, something went wrong."
                            showIcon
                            description={error.message}
                            type="error"
                            action={
                              <Button
                                onClick={() => {
                                  resetErrorBoundary();
                                }}
                                size="small"
                                danger
                              >
                                Reset
                              </Button>
                            }
                          />
                        </div>
                      </>
                    )}
                  >
                    <OfferingAutomations contextOfferingId={liveEventData.id} />
                  </ErrorBoundary>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Attendees and insights" key="insights">
                  <AttendeesComponent />
                </Tabs.TabPane>
                {/* <Tabs.TabPane tab="Co-hosts" key="3">
                <CoHostList />
              </Tabs.TabPane> */}
              </Tabs>
            </Spin>
          </div>
        </div>
        <div className="widget-area">
          <ShareClassWidget isFetching={isFetchingLiveEvent} classData={liveEventData} />
          <LiveClassesTemplateWidget />
        </div>
      </StyledPageWrapper>
    </DashboardWrapper>
  );
};

export {ViewLiveClassPage};
